import { Typography } from "@mui/material";
import { TextLogycaProps, TextLogycaType } from "./model";
import "./style.scss";

export function TextLogyca({ type, children }: TextLogycaProps) {
  return (
    <Typography
      className={
        type === TextLogycaType.NAV_BAR_SERCTION
          ? "TextLogycaNavBarSection"
          : type === TextLogycaType.NAV_BAR_MENU
          ? "TextLogycaNavBarMenu" 
          : type === TextLogycaType.LIST_TITTLE
          ? "TextLogycaListTitle"
          : type === TextLogycaType.LIST_DESCRIPTION
          ? "TextLogycaListDescription"
          : type === TextLogycaType.CARD_TITTLE
          ? "TextLogycaCardTitle"
          : type === TextLogycaType.CARD_DESCRIPTION
          ? "TextLogycaCardDescription"
          : ""
      }
      variant={
        type === TextLogycaType.LIST_TITTLE ||
        type === TextLogycaType.CARD_TITTLE
          ? "h3"
          : "body2"
      }
      component="div"
    >
      {children}
    </Typography>
  );
}
